module.exports = __webpack_public_path__ + "static/media/festival_white.c8dd70f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/festival_white.svg
// module id = 918
// module chunks = 0